module.exports = __webpack_public_path__ + "img/icon-clue.4f42315a.svg";